export const LINEWALKER_LIST = 'LINEWALKER_LIST';
export const LINEWALKER_LIST_SUCCESS = 'LINEWALKER_LIST_SUCCESS';
export const LINEWALKER_LIST_ERROR = 'LINEWALKER_LIST_ERROR';
export const LINEWALKER_DETAILS = 'LINEWALKER_DETAILS';
